// extracted by mini-css-extract-plugin
module.exports = {"row":"TableRow-module__row--1Pfdu","rowHasOnClick":"TableRow-module__rowHasOnClick--ElL2D"};